import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Modal, Stack, Typography } from '@esgian/esgianui';
import CloseIcon from '@mui/icons-material/Close';

function ConfirmModal({ type, onConfirm, onCancel }) {
  const title = type === 'activate' ? 'Activate Report' : 'Archive Report';
  const message =
    type === 'activate'
      ? 'Are you sure you want to activate this report? It will be sent out according to the schedule.'
      : 'Are you sure you want to archive this report? It will no longer be active or sent out, but you can view it in the archived reports section.';

  return (
    <Modal
      closeIcon={<CloseIcon fontSize="small" />}
      PaperProps={{
        sx: {
          background: ({ palette }) => palette.neutral.neutral01
        }
      }}
      size="xs"
      open
      handleClose={onCancel}
      DialogActionsProps={{ sx: { justifyContent: 'flex-end', px: 3, gap: 1 } }}
      actions={[
        <Button
          key="cancel-button"
          onClick={onCancel}
          sx={{ color: (theme) => theme.palette.secondary.contrastText }}
          color="secondary"
          variant="text">
          Cancel
        </Button>,
        <Button
          key="confirm-button"
          onClick={onConfirm}
          variant="contained"
          color={type === 'archive' ? 'error' : 'primary'}
          sx={{ borderRadius: '100px' }}>
          {type === 'activate' ? 'Activate' : 'Archive'}
        </Button>
      ]}
      title={title}>
      <Box sx={{ p: 3 }}>
        <Typography variant="body1">{message}</Typography>
      </Box>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  type: PropTypes.oneOf(['activate', 'archive']).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ConfirmModal;
